module.exports = __webpack_public_path__ + "img/capsule.9f9ec575.svg";